__turbopack_context__.v({
  "catalog": "_69u8jq_catalog",
  "copy": "_69u8jq_copy",
  "count": "_69u8jq_count",
  "group": "_69u8jq_group",
  "pagination": "_69u8jq_pagination",
  "preview": "_69u8jq_preview",
  "provenance": "_69u8jq_provenance",
  "referenceLink": "_69u8jq_referenceLink",
  "scroller": "_69u8jq_scroller",
  "search": "_69u8jq_search",
  "status": "_69u8jq_status",
  "swatch": "_69u8jq_swatch",
  "toolbar": "_69u8jq_toolbar",
  "value": "_69u8jq_value",
});
